<template>
  <div>
    <mychart :options="options" v-if="options !== null" :chartID="chartid"></mychart>
  </div>
</template>

<script>
import mychart from './Chart'
function BoxPlotData (vueobj, exprdata) {
  let tumorexpr = exprdata.filter(d => d.isTumor === '1').map(d => Number(d.exprcount))
  let normaolexpr = exprdata.filter(d => d.isTumor !== '1').map(d => Number(d.exprcount))
  return vueobj.echarts.dataTool.prepareBoxplotData([normaolexpr, tumorexpr])
}

export default {
  components: {
    mychart
  },
  props: ['exprData'],
  name: 'BoxPlot',
  data: () => ({
    options: null,
    chartid: Math.random() * 100000000000000000
  }),
  mounted () {
    this.myBoxPlot()
  },
  watch: {
    exprData: function () {
      this.myBoxPlot()
    }
  },
  methods: {
    myBoxPlot: function () {
      var data = BoxPlotData(this, this.exprData)
      this.options = {
        title: [
          {
            text: 'Expression BoxPlot'
          }],
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          data: ['Normal', 'Tumor'],
          name: 'Group',
          nameLocation: 'center',
          nameGap: 45
        },
        yAxis: {
          type: 'value',
          name: 'Count',
          nameLocation: 'center',
          nameGap: 45
        },
        series: [
          {
            name: 'boxplot',
            type: 'boxplot',
            data: data.boxData
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BoxPlot.vue